export default __webpack_public_path__ + "static/media/magnifier.9be5cabe.svg";